const IconMP3 = ({ className }) => {
    return (
        <svg viewBox='0 0 23 23' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8 4C8 3.44772 8.44772 3 9 3H19C19.5523 3 20 3.44772 20 4V17C20 19.2091 18.2091 21 16 21C13.7909 21 12 19.2091 12 17C12 14.7909 13.7909 13 16 13C16.7286 13 17.4117 13.1948 18 13.5351V9H10V17C10 19.2091 8.20914 21 6 21C3.79086 21 2 19.2091 2 17C2 14.7909 3.79086 13 6 13C6.72857 13 7.41165 13.1948 8 13.5351V4ZM10 7H18V5H10V7ZM8 17C8 15.8954 7.10457 15 6 15C4.89543 15 4 15.8954 4 17C4 18.1046 4.89543 19 6 19C7.10457 19 8 18.1046 8 17ZM18 17C18 15.8954 17.1046 15 16 15C14.8954 15 14 15.8954 14 17C14 18.1046 14.8954 19 16 19C17.1046 19 18 18.1046 18 17Z'
            />
        </svg>
    );
};

export default IconMP3;
